export default __webpack_public_path__ + "static/media/3088.0e015712.jpg";